






















import { Component, Vue, Prop } from "vue-property-decorator";
import { SubProject } from "../models/subProject";
import SubProjectBlock from "./SubProjectBlock.vue";

@Component({
  components: { SubProjectBlock },
})
export default class SubProjectList extends Vue {
  @Prop({ required: true, type: Array }) public value!: SubProject[];
  @Prop({ required: true, type: Number }) public projectId!: number;

  private rowsPerPageItems = [3, 6, 9];
  private pagination = {
    rowsPerPage: 3,
    descending: true,
    sortBy: "start_date",
  };
}
